import { cmpCookie } from "@foundation/cmp-client";
import PerformanceMonitor from "../util/monitoring/PerformanceMonitor";
import makeMeasure from "../util/makeMeasure";
import DependencyLoader from "../DependencyLoader";
import { Storage } from "../util/Storage";
import GPT from "../gpt/GPT";
import fireEREvt from "../util/eventRecorderClient";

const local = Storage.createLocalStorage();
const bomboraUrl = "https://vi.ml314.com/get?eid=50066&tk=aO1CCthMyYq5eNlVwlKQXL9igGlRPy95K4LLnm84p2bE3d&fp=";

export default class Bombora extends DependencyLoader {

    private _gpt: GPT;
    private _measure = makeMeasure(new PerformanceMonitor("Sparkle:Bombora"));

    constructor(gpt: GPT) {
        super();
        this._gpt = gpt;
    }

    init() {
        // Gate both the script load and the targeting: loading the script
        // alone already sends the _ccmaid identifier to Bombora.
        if (!cmpCookie.padAllowed()) {
            fireEREvt("ad-bombora-no-consent");

            return;
        }

        this.loadBombora();
        this.addBomboraTargeting();
    }

    loadBombora() {
        // if script/stub already setup, no need to do it again
        if (window._bmb) return;

        this.setupStub();
        this._measure("loadBombora", () => this.loadScriptDependency(this.getUrl()))
            .catch((e) => console.error(`Error init Bombora Script:  ${ e }`));
    }

    setupStub() {
        // @ts-expect-error bombora stub taken from docs
        // eslint-disable-next-line
        const o = window._bmb = function () { o.x ? o.x.apply(o, arguments) : o.q.push(arguments) };

        // @ts-expect-error bombora stub taken from docs
        o.q = [];
    }

    getUrl() {
        const ccmaid = local.get("_ccmaid") ?? "";

        return `${ bomboraUrl }${ ccmaid }`;
    }

    addBomboraTargeting() {
        if (!window._bmb) return;

        window._bmb("vi", (data) => {
            if (data) {
                const tmpSegment = [
                    data.industry_id,
                    data.revenue_id,
                    data.size_id,
                    data.functional_area_id,
                    data.professional_group_id,
                    data.seniority_id,
                    data.decision_maker_id,
                    data.install_data_id,
                    data.topic_id,
                    data.interest_group_id,
                    data.segment,
                    data.b2b_interest_cluster_id
                ].filter(Boolean).join(",");

                if (tmpSegment !== "") {
                    this._gpt.setTargeting("bmb", tmpSegment.split(","));
                }
            }
        });
    }

}
